export default __webpack_public_path__ + "static/media/sushi-box.bbabcf36.jpg";